<template>
	<div  v-wechat-title="this.contentarr.title+' 在线阅读'">
		<Header>
			<div class="leftcss"><a @click='goBack'><i class="iconfont icon---"></i></a></div>
			<div class="ccentercss"> <router-link to="/"><span>首页</span></router-link> > <router-link :to="'/c'+this.$route.params.nid">{{ctitlearr}}</router-link></div>
			<div class="ccrightcss"><span class ="ctudh"><router-link :to="'/dztu-'+this.$route.params.id">图</router-link></span><span id="show-modal" @click="showModal = true"><i class="iconfont icon-zhedie1"></i></span><modal v-if="showModal" @close="showModal = false" > </modal></div>
		</Header>
		<div class="body-main">
			<div class="contenttitle" :class="{'dark':themeName=='dark'}"><h1>{{contentarr.title}}</h1><span class ="zihao12" >{{contentarr.author}}</span></div>
			<div class="ctleft">{{contentarr.remark}}</div>
			<div  class="contentmain" v-html="contentarr.content"> </div>
			<GoTop/>
		</div>
	</div>
</template>
<script>
	import Header from '@/components/Header.vue'
	import GoTop from '@/components/gotop.vue'
	import modal from '@/components/modal.vue'
	import axios from 'axios'
	export default {
		data() {
			return {
				showModal: false,
				contentarr: [],
				ctitlearr: '',


			}
		},
		components: {
			Header,
			GoTop,
			modal 
		},
		mounted() {
			this.getcontent();
			this.getctitle();
		},
		methods: {
			getcontent: function() {
				var _self = this;
				axios.get('https://m.daorenjia.com/api/neirongapi.php?id=' + this.$route.params.id).then(function(response) {
					//console.log(response);
					_self.contentarr = response.data;
				})
			},
			getctitle: function() {
				var _sself = this;
				axios.get('https://m.daorenjia.com/api/ctitleapi.php?nid=' + this.$route.params.nid).then(function(response) {
					//console.log(response);
					_sself.ctitlearr = response.data;
				})
			},
			
			goBack() {
				window.history.length > 1 ?
					this.$router.go(-1) :
					this.$router.push('/')
			}
		}


	}
</script>
<style>

	.contenttitle{
		margin: 2vh 0 0 0;
		padding-bottom: 1vh;
		text-align: center;
		border-bottom: solid #CCCCCC 0.27vmin;
	}
	.contenttitle.dark{
		border-bottom: 1px solid #808080;
	}
	.ctleft{
		margin-top: 1vh;
		padding: 0;
		text-align: left;
		font-size: 0.8em;
		display: flex;
	}
	.contentmain{
		margin: 1vh 0 0 0;
		 font-family: dzfont;
	}
	.contentmain img{
		max-width: 90vw;
	}
	table{
		font-size: 3.5vmin;
		border-collapse: collapse;	 
	}
	tr, td {
		list-style: none;
		text-indent: 6.75vmin;
		margin: 0;
		line-height: 5.4vmin;
		padding: 2.16vmin;
		letter-spacing: 0;
	}
	.ccentercss{ 
		text-align: left;
		padding: 0;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.ccrightcss{
		margin-left: auto; 
		line-height: 7.2vmax;
		text-align: right;
	}
	.ctudh{
		margin-right: 4vw;
	}
	.zihao12{
		font-size: 0.8em;
	}
	.nli{
		margin: 2.7vmin 0 2.7vmin 0;
		text-indent: 8vmin;
		line-height: 7.2vmin;
	}
	.nlik{
		margin: 2.7vmin 0 2.7vmin 0;
		text-indent: 8vmin;
		line-height: 7.2vmin;
	}
	
 
</style>
